import { ArrowBack } from '@mui/icons-material';
import { Box, Button, Card, Typography, useTheme } from '@mui/material';
import CourseContentItem from './CourseContentItem';
import LectureContentSelector from './LectureContentSelector';
import { useState } from 'react';
import VideoItem from './VideoItem';
import TextItem from './TextItem';
import QuizItem from './QuizItem';
import AssignmentItem from './AssignmentItem';

export default function CourseContent({ course }) {
  const theme = useTheme();
  const [lecture, setLecture] = useState(
    course.lectures?.find((lec) => lec.id === course.currentLectureId) ||
      course.lectures?.[0],
  );
  const [item, setItem] = useState(
    lecture?.items?.find((it) => it.id === lecture.currentItemId) ||
      lecture?.items?.[0],
  );
  const currentItemIndex = lecture.items.findIndex((it) => it.id === item.id);

  function next() {
    if (currentItemIndex < lecture.items.length - 1) {
      const nextItem = lecture.items[currentItemIndex + 1];
      setItem(nextItem);
    }
  }
  function back() {
    if (currentItemIndex > 0) {
      const prevItem = lecture.items[currentItemIndex - 1];
      setItem(prevItem);
    }
  }

  return (
    <Box
      sx={{
        width: '1200px',
        maxWidth: '90%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        justifySelf: 'center',
        gap: 2,
        py: 4,
        flexDirection: 'row',
        [theme.breakpoints.down('sm')]: {
          flexDirection: 'column',
        },
      }}
    >
      <Box
        sx={{
          width: '300px',
          gap: 2,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Card
          sx={{
            p: 2,
            display: 'flex',
            flexDirection: 'column',
            gap: 0.5,
          }}
        >
          <Typography
            sx={{
              fontWeight: 'bold',
              mb: 1,
            }}
          >
            Kursinhalte
          </Typography>
          {course.lectures?.map((item, index) => (
            <CourseContentItem
              key={index}
              title={item.title}
              duration={item.duration}
              icon={item.icon}
              active={item.id === lecture.id}
              completed={item.completed}
              onClick={() => {
                setLecture(item);
                setItem(
                  item.items?.find((it) => it.id === item.currentItemId) ||
                    item.items?.[0],
                );
              }}
            />
          ))}
        </Card>
        <Button fullWidth startIcon={<ArrowBack />} to="/learning">
          Zurück zur Kursübersicht
        </Button>
      </Box>
      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <LectureContentSelector
          items={lecture?.items}
          item={item}
          setItem={setItem}
        />
        {item?.type === 'video' && <VideoItem item={item} />}
        {item?.type === 'text' && <TextItem item={item} />}
        {item?.type === 'quiz' && <QuizItem item={item} />}
        {item?.type === 'assignment' && <AssignmentItem item={item} />}
        <Box sx={{ display: 'flex', flexDirection: 'row', mb: 2 }}>
          {currentItemIndex > 0 && <Button onClick={back}>Zurück</Button>}
          <Box sx={{ flex: 1 }} />
          {currentItemIndex < lecture.items.length - 1 ? (
            <Button onClick={next} variant="contained">
              Weiter
            </Button>
          ) : (
            <Button onClick={next} variant="contained">
              Lektion abschließen
            </Button>
          )}
        </Box>
      </Box>
    </Box>
  );
}
